let registration: ServiceWorkerRegistration;

export const register = (licenseId?: number): void => {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker
      .register(`/service-worker.js${licenseId ? `?id=${licenseId}` : ""}`)
      .then(sw => {
        registration = sw;
      })
      .catch(err => {
        // FIXME: Fix this the next time the file is edited.
        // eslint-disable-next-line no-console
        console.error(err);
      });
  }
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const makeSubscription = async (applicationServerKey: string) => {
  const subscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey,
  });

  return subscription.toJSON();
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const enableNotifications = async (applicationServerKey: string) => {
  if (Notification.permission === "granted" || (await Notification.requestPermission()) === "granted") {
    const subscription = await makeSubscription(applicationServerKey);
    return subscription;
  }
  return null;
};
